var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _g, _path119, _path120, _g2, _path121, _path122, _g3, _path123, _path124, _g4, _path125, _path126, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroB2B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 530,
    viewBox: "0 0 800 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_882)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M770 0H30C13.4315 0 0 13.4315 0 30V500C0 516.569 13.4315 530 30 530H770C786.569 530 800 516.569 800 500V30C800 13.4315 786.569 0 770 0Z",
    fill: "#F9FDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400.427 609.942C590.697 609.942 744.942 455.697 744.942 265.427C744.942 75.157 590.697 -79.087 400.427 -79.087C210.157 -79.087 55.913 75.157 55.913 265.427C55.913 455.697 210.157 609.942 400.427 609.942ZM400.427 671.854C624.891 671.854 806.854 489.891 806.854 265.427C806.854 40.964 624.891 -141 400.427 -141C175.964 -141 -6 40.964 -6 265.427C-6 489.891 175.964 671.854 400.427 671.854Z",
    fill: "#EFFAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-286.6 287.666C-311 308.999 -331.134 326.866 -331.267 327.399C-331.534 327.933 -324.734 336.066 -316.467 345.666C-306.6 356.866 -301.8 363.399 -302.867 363.933C-303.667 364.466 -309.4 364.999 -315.534 364.999C-325.534 364.999 -326.467 365.266 -325.534 367.266C-320.2 379.533 -328.467 393.399 -339.667 390.999C-348.334 389.133 -353 376.733 -348.467 367.799C-346.334 363.933 -346.334 363.533 -348.6 362.866C-350.6 362.333 -361.134 358.199 -365.8 356.199C-368.334 355.133 -369.134 365.399 -367.134 373.133L-365.267 380.333L-373.667 409.666C-383.667 443.933 -387.534 459.399 -392.334 482.733L-395.8 499.799L-393.8 522.066C-391.534 545.266 -383.534 613.666 -380.334 635.666C-376.867 659.799 -370.2 708.733 -360.2 782.333C-342.867 910.999 -333 978.599 -331 982.466C-329.934 984.466 -325.4 989.266 -321 993.133L-313.134 1000.2L-316.734 1006.73C-323.267 1018.73 -337.134 1027.13 -360.2 1033C-372.467 1036.2 -375.534 1037.53 -378.6 1040.87C-380.734 1043.13 -382.334 1045.93 -382.334 1047C-382.334 1048.73 -389 1049 -432.334 1049C-471.267 1049 -482.467 1048.6 -482.867 1047.27C-483.4 1045.67 -490.067 716.999 -491 650.599L-491.534 615.666H-483.667C-477.267 615.666 -475.134 614.999 -472.067 612.466C-468.6 609.399 -468.334 608.599 -468.334 599.133C-468.334 590.466 -468.734 588.599 -471.4 586.066L-474.467 582.999H-638.734C-729.133 582.999 -865.8 582.866 -942.6 582.599L-1082.33 582.333V575.399L-1091.93 576.199C-1097.27 576.733 -1110.6 577.666 -1121.4 578.199C-1132.33 578.866 -1141.4 579.666 -1141.8 580.066C-1143.13 581.399 -1150.47 608.999 -1153 622.333C-1158.73 651.799 -1158.6 684.333 -1152.87 702.999C-1149 715.666 -1145.93 720.333 -1139.13 723.533C-1133.8 726.199 -1131.13 726.333 -1097.93 726.333H-1062.33V729.933C-1062.33 732.066 -1063.8 802.599 -1065.67 886.999C-1067.53 971.266 -1069 1042.33 -1069 1044.6V1049H-1321.4C-1515.93 1049 -1574.2 1049.4 -1575.4 1050.6C-1577.53 1052.73 -1577.4 1059 -1575.13 1060.87C-1573.8 1061.93 -1134.07 1062.2 107.8 1062.07L1789 1061.67V1049.67L1527.13 1049.27C1278.6 1049 1265.4 1048.87 1266.33 1046.6C1267.8 1042.87 1270.87 1024.73 1271 1019.27C1271 1016.07 1271.67 1013.93 1273 1013.53C1277.8 1011.67 1273.53 895.133 1266.33 830.999C1263.27 804.066 1257.93 774.199 1252.33 752.333C1241.93 711.666 1239.67 686.066 1239.67 610.999C1239.8 560.199 1241.53 508.733 1243.8 489.933L1244.6 483.399L1239.27 486.999C1231.13 492.466 1216.07 498.066 1201.13 501.266C1189.13 503.933 1183.93 504.333 1152.33 504.199C1120.73 504.199 1115.53 503.933 1103.27 501.266C1088.87 498.066 1070.07 491.799 1064.87 488.333C1063.13 487.266 1061.4 486.333 1060.87 486.333C1059.67 486.333 1061.13 533.799 1063.8 579.666C1067.27 643.133 1072.2 694.466 1081.67 766.999C1094.6 866.066 1100.47 944.866 1098.33 990.866C1097.53 1006.87 1097.8 1010.87 1099.13 1011.93C1100.6 1012.73 1099.4 1014.6 1094.07 1019.67C1085.4 1027.67 1072.2 1034.33 1057.13 1038.33C1049.67 1040.33 1044.33 1042.6 1041.93 1044.87L1038.33 1048.2L453.4 1048.47L-131.534 1048.73L-128.334 1043.93C-126.6 1041.27 -124.467 1035.93 -123.534 1032.33C-121.267 1023 -119.534 1019.8 -110.6 1009.4C-101.267 998.599 -99.667 995.799 -99.667 990.333C-99.667 984.199 -102.867 978.466 -112.2 967.666L-120.467 958.066L-122.067 925.933C-125.4 861.266 -132.734 819.133 -152.6 749.666C-158.067 730.599 -163.4 711.266 -164.467 706.866C-167.534 693.266 -170.334 666.066 -171.667 634.999C-178.6 474.199 -179.534 465.799 -190.334 439.666L-195.667 426.999L-192.067 423.799C-189.934 422.066 -175.934 409.799 -160.734 396.599L-133.134 372.599L-141.267 363.533C-145.8 358.333 -149.934 354.733 -150.867 355.266C-151.667 355.666 -155 357.933 -158.067 360.066C-171.4 368.999 -201.8 380.866 -228.867 387.666C-235 389.266 -240.867 390.199 -241.934 389.799C-243.134 389.266 -246.867 391.799 -251.4 396.066C-261.667 405.666 -266.2 408.999 -269.134 408.999C-272.334 408.999 -277.4 401.133 -280.467 391.933C-282.6 385.266 -282.6 384.733 -280.334 382.333C-277.8 379.533 -269.267 376.333 -258.467 374.333C-254.467 373.533 -250.867 372.466 -250.467 371.933C-249.934 371.399 -244.2 366.199 -237.667 360.333C-212.867 338.333 -197.134 323.399 -193.8 318.599C-187.667 309.666 -188.6 308.066 -224.334 267.266C-233.134 257.266 -240.734 248.999 -241.134 248.999C-241.667 248.999 -262.067 266.466 -286.6 287.666ZM-519.8 616.466C-518.867 617.266 -518.6 622.199 -507.267 838.333C-501.667 943.533 -496.867 1034.07 -496.467 1039.27L-495.667 1049H-876.867L-877.667 1045.93C-878.2 1044.33 -880.733 1039.27 -883.533 1034.6C-887.533 1027.67 -889.667 1025.4 -895.667 1022.2C-913.267 1012.87 -925 1000.33 -937.8 976.999C-946.067 961.933 -950.867 954.333 -951.8 954.333C-952.2 954.333 -955.4 956.733 -958.867 959.799C-963.933 964.333 -965 966.066 -965 969.933C-965 976.333 -959 984.466 -946.2 995.266C-940.2 1000.47 -932.733 1008.33 -929.133 1013.67C-920.867 1025.53 -906.733 1039.8 -898.6 1044.6L-892.333 1048.33L-973.533 1048.73C-1018.2 1048.87 -1055 1048.73 -1055.4 1048.33C-1055.8 1047.93 -1052.33 976.466 -1047.8 889.399C-1043.27 802.199 -1039.67 729.933 -1039.67 728.599C-1039.67 726.466 -1036.07 726.333 -982.2 726.333H-924.867L-918.867 722.199C-909.933 716.066 -897.133 703.666 -890.333 694.599C-885 687.399 -881.4 684.066 -880.2 685.266C-880.067 685.533 -881.933 691.666 -884.467 698.999C-897 734.733 -910.2 803.266 -918.333 873.666C-919.8 886.866 -921.267 899.399 -921.667 901.399C-922.2 904.599 -921.533 905.533 -915.933 909.133C-903 917.399 -877.267 921.666 -875 915.933C-874.2 913.666 -834.333 805.799 -822.733 774.333C-819.267 765.133 -816.333 757.399 -816.2 757.266C-816.067 756.999 -803.933 768.866 -789.4 783.666C-762.333 811.266 -737 835.133 -698.333 869.399L-676.334 888.999H-665.534C-653.4 888.999 -642.734 886.333 -637.534 881.933L-634.067 878.866L-639.667 867.666C-678.867 789.533 -745.533 672.733 -776.467 628.066C-781.133 621.399 -785 615.399 -785 614.866C-785 613.933 -520.734 615.533 -519.8 616.466ZM-251.934 786.466C-233.267 831.399 -172.334 959.399 -166.6 965.399C-164.734 967.399 -160.734 969.666 -157.934 970.466L-152.734 971.799L-153.267 994.733C-153.667 1016.73 -153.8 1017.93 -157.4 1025.27C-161.534 1033.67 -165 1036.6 -174.734 1040.2C-179 1041.8 -181.534 1043.67 -182.334 1045.8L-183.667 1049H-229.8C-273.267 1049 -275.934 1048.87 -274.867 1046.6C-274.2 1045.4 -273.534 1032.2 -273.4 1017.53C-273.267 1002.73 -271.934 972.733 -270.467 950.866C-265.934 883.933 -261 792.066 -261 773.133C-261 769.133 -260.734 766.199 -260.467 766.466C-260.2 766.733 -256.334 775.799 -251.934 786.466ZM1187 878.333C1199.4 922.733 1211.53 975.533 1217 1009.27C1217.67 1013.27 1218.33 1014.33 1220.73 1014.33C1223.27 1014.47 1222.73 1015.27 1217.13 1020.33C1208.07 1028.47 1198.07 1033.4 1181.67 1038.2C1171.53 1041.13 1166.87 1043.13 1164.73 1045.67C1162.07 1048.73 1160.87 1049 1151.67 1049C1140.47 1049 1141.27 1049.8 1143.93 1040.6C1144.33 1039 1145.4 1032.2 1146.33 1025.67C1147.8 1013.93 1147.93 1013.67 1151.27 1013.93C1154.6 1014.07 1154.73 1013.67 1157.4 999.266C1165.27 957.533 1173.53 902.066 1176.33 872.333C1177.93 856.466 1178.6 852.199 1179.53 853.133C1179.8 853.399 1183.13 864.733 1187 878.333Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M615.113 509.391C638.026 509.391 674.099 470.596 648.914 418.214C617.932 353.777 583.412 370.904 623.859 255.016C645.386 193.34 569.633 138.374 507.655 174.401C472.659 194.744 411.813 210.542 391.852 170.884C348.586 84.927 196.46 79 159.398 167.917C119.709 263.137 217.45 298.264 184.309 347.701C165.372 375.951 141.463 387.328 143.306 427.791C146.31 493.769 219.812 508.968 273.35 508.968L615.113 509.391Z",
    fill: "#EFFAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M585.235 128.798C583.115 128.801 581.013 129.189 579.032 129.945C579.047 129.564 579.06 129.183 579.06 128.798C579.06 113.784 566.889 101.613 551.875 101.613C537.601 101.613 525.906 112.617 524.787 126.603C521.541 123.482 517.136 121.551 512.276 121.551C505.126 121.551 498.965 125.714 496.037 131.739C492.431 123.969 484.581 118.569 475.451 118.569C462.91 118.569 452.745 128.734 452.745 141.274C452.745 153.815 462.91 163.98 475.451 163.98H585.235C594.951 163.98 602.826 156.105 602.826 146.389C602.826 136.673 594.951 128.798 585.235 128.798ZM337.568 47.184C339.756 47.184 341.84 47.6 343.772 48.33C343.757 47.95 343.743 47.567 343.743 47.184C343.743 32.169 355.915 19.999 370.928 19.999C385.202 19.999 396.898 31.002 398.016 44.989C401.263 41.867 405.667 39.938 410.527 39.938C417.677 39.938 423.838 44.1 426.766 50.126C430.372 42.356 438.222 36.954 447.354 36.954C459.893 36.954 470.059 47.12 470.059 59.66C470.059 72.2 459.893 82.365 447.354 82.365H337.568C327.853 82.365 319.977 74.49 319.977 64.774C319.977 55.06 327.853 47.184 337.568 47.184Z",
    fill: "#E2F0FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M654.789 254.688L606.073 261.305L557.359 267.923C552.061 268.643 549.53 274.827 552.803 279.053L572.167 304.076L497.007 365.795C494.778 367.626 491.984 368.629 489.099 368.635C486.214 368.64 483.416 367.647 481.18 365.825L451.646 341.76C449.605 340.096 447.09 339.12 444.461 338.971C441.832 338.821 439.223 339.506 437.006 340.927L330.277 409.349C328.563 410.448 326.607 411.111 324.579 411.282C322.551 411.452 320.511 411.125 318.638 410.328L292.323 399.132C290.446 398.333 288.402 398.006 286.37 398.179C284.337 398.352 282.378 399.019 280.663 400.124L172.877 469.543C164.428 474.983 161.989 486.245 167.431 494.695C170.605 499.624 175.758 502.506 181.179 502.973C185.19 503.323 189.204 502.326 192.585 500.14L284.157 441.164C285.872 440.059 287.832 439.391 289.865 439.218C291.897 439.045 293.942 439.372 295.819 440.171L322.087 451.349C323.96 452.146 325.999 452.473 328.028 452.303C330.056 452.132 332.012 451.469 333.726 450.371L434.453 385.797C436.67 384.375 439.279 383.691 441.909 383.84C444.538 383.99 447.053 384.966 449.094 386.63L481.266 412.846C483.502 414.668 486.3 415.66 489.185 415.655C492.07 415.649 494.864 414.646 497.093 412.816L594.453 332.872L612.98 356.813C616.251 361.041 622.872 360.141 624.898 355.193L643.523 309.696L662.15 264.2C664.176 259.252 660.085 253.968 654.789 254.688Z",
    fill: "#F68D11"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168.725 323.005C168.725 360.408 138.402 390.729 100.999 390.729C63.597 390.729 33.276 360.408 33.276 323.005C33.276 285.602 63.596 255.282 100.999 255.282C138.402 255.282 168.725 285.602 168.725 323.005Z",
    fill: "#FFBC0E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M176 323.001C176 364.421 142.422 398.002 100.999 398.002C59.579 398.002 26 364.421 26 323.001C26 281.579 59.58 248.001 100.999 248.001C142.422 248.001 176 281.579 176 323.001Z",
    stroke: "#FFBC0E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.196 281.891C114.282 273.432 131.752 295.909 129.246 313.791C128.157 331.418 107.53 342.315 109.403 348.973H92.306C92.306 348.973 93.522 345.695 89.066 341.76C72.256 328.51 61.424 295.269 91.196 281.891Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.404 348.969C109.309 357.053 111.367 366.798 99.614 365.899C90.384 365.597 92.471 355.177 92.296 348.969H109.404Z",
    fill: "#F68D11"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.277 348.973C104.277 348.973 103.967 322.07 106.335 314.608C108.706 307.148 113.445 301.387 116.948 307.802C123.688 328.19 87.523 333.304 84.701 315.262C80.971 297.862 100.545 296.381 97.277 348.973",
    stroke: "#FFBC0E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M226.725 101.001C226.725 138.404 196.405 168.725 159.001 168.725C121.598 168.725 91.275 138.404 91.275 101.001C91.275 63.595 121.598 33.274 159.001 33.274C196.405 33.274 226.725 63.595 226.725 101.001Z",
    fill: "#FFBC0E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M234 101.001C234 142.422 200.422 176 159.001 176C117.578 176 84 142.422 84 101.001C84 59.578 117.578 26 159.001 26C200.422 26 234 59.578 234 101.001Z",
    stroke: "#FFBC0E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M197.583 99.497C197.583 120.807 180.308 138.082 159.001 138.082C137.691 138.082 120.416 120.807 120.416 99.497C120.416 78.19 137.691 60.915 159.001 60.915C180.308 60.915 197.583 78.19 197.583 99.497Z",
    stroke: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.986 117.71C148.09 119.466 145.042 118.947 143.835 116.661L136.203 102.231C135.966 101.783 135.82 101.293 135.772 100.789C135.725 100.284 135.777 99.7753 135.926 99.2911C136.075 98.8069 136.319 98.3568 136.642 97.9666C136.965 97.5764 137.362 97.2538 137.81 97.017C138.258 96.7797 138.748 96.633 139.252 96.5853C139.757 96.5376 140.266 96.5899 140.75 96.7392C141.234 96.8884 141.684 97.1317 142.074 97.4552C142.464 97.7786 142.787 98.1758 143.023 98.624L148.352 108.704L175.767 83.324C176.138 82.9781 176.573 82.709 177.048 82.5322C177.524 82.3553 178.029 82.2742 178.536 82.2936C179.042 82.3129 179.54 82.4323 180.001 82.6448C180.461 82.8574 180.875 83.1589 181.218 83.532C181.563 83.9034 181.831 84.339 182.007 84.8141C182.183 85.2891 182.264 85.7942 182.244 86.3004C182.225 86.8067 182.106 87.3042 181.895 87.7645C181.683 88.2248 181.383 88.6389 181.011 88.983L149.986 117.71ZM198.311 134.347C198.311 144.46 190.112 152.656 180 152.656C169.889 152.656 161.69 144.46 161.69 134.347C161.69 124.234 169.889 116.037 180 116.037C190.112 116.037 198.311 124.234 198.311 134.347Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M195.59 134.35C195.59 142.961 188.61 149.941 179.999 149.941C171.39 149.941 164.41 142.961 164.41 134.35C164.41 125.739 171.39 118.759 179.999 118.759C188.61 118.759 195.59 125.739 195.59 134.35Z",
    fill: "#FFBC0E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M181.898 136.963C181.858 136.256 181.273 136.066 180.609 135.719V138.085C181.468 137.937 181.898 137.565 181.898 136.963ZM178.083 131.199C178.115 131.924 178.62 132.101 179.307 132.444V130.213C178.49 130.333 178.083 130.662 178.083 131.199ZM184.756 136.82C184.733 139.124 182.877 140.131 180.609 140.343V142.289H179.307V140.38C177.763 140.35 176.409 140.078 175.245 139.563V137.058C175.74 137.34 178.423 138.202 179.307 138.15V135.207C174.268 134.295 173.776 128.084 179.307 127.859V126.405H180.609V127.822C182.057 127.884 183.367 128.174 184.538 128.694L183.646 130.915C182.677 130.516 181.653 130.266 180.609 130.175V132.976C182.882 133.94 184.641 134.435 184.756 136.82Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M755.724 126.006C755.724 163.41 725.404 193.73 688 193.73C650.597 193.73 620.274 163.41 620.274 126.006C620.274 88.603 650.597 58.282 688 58.282C725.404 58.282 755.724 88.603 755.724 126.006Z",
    fill: "#FFBC0E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M763 126.001C763 167.424 729.422 201.002 688.001 201.002C646.578 201.002 613 167.424 613 126.001C613 84.581 646.578 50.999 688.001 50.999C729.422 51 763 84.58 763 126.001Z",
    stroke: "#FFBC0E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M660.96 134.365C660.96 134.365 661.849 147.059 661.927 152.455C661.964 155.01 662.326 156.937 662.696 158.256C662.87 158.869 663.265 159.395 663.804 159.735C664.343 160.074 664.989 160.202 665.617 160.094L672.799 158.873C673.149 158.814 673.482 158.684 673.779 158.49C674.076 158.296 674.33 158.043 674.525 157.747C674.72 157.451 674.852 157.118 674.912 156.769C674.973 156.419 674.961 156.061 674.877 155.717C673.561 150.301 670.825 138.217 671.47 133.891L660.96 134.365Z",
    fill: "#F68D11"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M654.288 118.619L655.779 132.739C655.833 133.249 656.079 133.719 656.467 134.055C656.855 134.39 657.356 134.566 657.868 134.547L676.747 133.835L675.605 113.927L656.761 115.611C656.4 115.643 656.049 115.747 655.729 115.916C655.408 116.086 655.125 116.317 654.895 116.597C654.664 116.877 654.492 117.2 654.388 117.547C654.284 117.894 654.25 118.259 654.288 118.619Z",
    fill: "#F68D11"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M675.605 113.929L708.697 92.594C711.225 90.966 714.605 92.247 715.407 95.145C718.09 104.843 722.609 125.426 719.711 145.984C719.437 147.945 717.395 149.136 715.542 148.437L676.747 133.837L675.605 113.929ZM654.39 119.58C653.85 119.622 653.324 119.772 652.842 120.021C652.361 120.27 651.935 120.613 651.588 121.03C651.242 121.446 650.983 121.928 650.826 122.447C650.669 122.965 650.618 123.51 650.675 124.049L651.125 128.259C651.183 128.797 651.347 129.318 651.609 129.792C651.87 130.266 652.224 130.683 652.649 131.018C653.073 131.353 653.561 131.6 654.083 131.745C654.604 131.889 655.149 131.928 655.686 131.859L654.39 119.58Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M718.936 111.441C718.936 111.441 725.384 113.555 725.346 118.988C725.309 124.422 720.647 128.02 720.647 128.02C720.647 128.02 719.408 114.632 718.936 111.441Z",
    fill: "#F68D11"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M719.711 145.984C722.609 125.426 718.09 104.843 715.407 95.145C714.605 92.247 711.225 90.965 708.697 92.595L707.737 93.211C708.954 95.909 711.277 102.02 712.566 111.706C714.233 124.202 715.587 138.082 713.82 147.79L715.542 148.437C717.395 149.136 719.436 147.945 719.711 145.984Z",
    fill: "#F68D11"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M242 205.626C242 289.92 310.332 358.254 394.626 358.254C478.92 358.254 547.252 289.92 547.252 205.626C547.252 121.333 478.92 53 394.626 53C310.332 53 242 121.333 242 205.626Z",
    fill: "#E8E8FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M254.625 205.626C254.625 282.946 317.306 345.627 394.626 345.627C471.945 345.627 534.626 282.946 534.626 205.626C534.626 128.307 471.945 65.628 394.626 65.628C317.306 65.628 254.625 128.307 254.625 205.626Z",
    stroke: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M344.146 206.818C344.146 284.75 368.889 347.928 399.409 347.928C429.93 347.928 454.672 284.75 454.672 206.818C454.672 128.884 429.93 65.708 399.409 65.708C368.889 65.708 344.146 128.884 344.146 206.818Z",
    stroke: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M396.035 274.496C437.216 274.496 474.239 283.533 499.857 297.912C474.197 327.147 436.581 345.627 394.626 345.627C353.192 345.627 315.979 327.613 290.345 299.009C316.013 283.998 353.828 274.496 396.035 274.496ZM501.993 115.807C476.321 130.908 438.389 140.477 396.035 140.477C352.654 140.477 313.888 130.449 288.208 114.711C313.886 84.683 352.019 65.627 394.626 65.627C437.754 65.627 476.313 85.142 501.993 115.807Z",
    stroke: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M356.428 244.137L359.491 224.741L367.257 225.968C368.684 226.193 369.841 226.593 370.727 227.167C371.614 227.74 372.238 228.441 372.599 229.268C372.961 230.089 373.065 230.985 372.912 231.957C372.792 232.715 372.535 233.357 372.142 233.884C371.749 234.404 371.258 234.806 370.67 235.088C370.067 235.371 369.415 235.535 368.75 235.571L368.72 235.76C369.448 235.906 370.127 236.234 370.695 236.713C371.291 237.211 371.748 237.855 372.021 238.582C372.316 239.334 372.389 240.187 372.238 241.141C372.075 242.17 371.675 243.048 371.035 243.775C370.404 244.497 369.555 245.014 368.49 245.324C367.425 245.635 366.167 245.676 364.714 245.446L356.428 244.137ZM361.058 241.432L364.401 241.961C365.544 242.141 366.412 242.055 367.005 241.702C367.598 241.343 367.953 240.797 368.069 240.065C368.154 239.528 368.099 239.034 367.905 238.583C367.701 238.12 367.37 237.724 366.949 237.442C366.513 237.133 365.966 236.927 365.31 236.823L361.872 236.28L361.058 241.432ZM362.31 233.506L365.35 233.986C365.912 234.074 366.426 234.055 366.893 233.928C367.341 233.811 367.748 233.574 368.069 233.241C368.386 232.915 368.585 232.497 368.665 231.986C368.776 231.285 368.616 230.68 368.185 230.172C367.76 229.665 367.094 229.34 366.184 229.196L363.068 228.704L362.31 233.506ZM389.46 248.611V245.62L396.449 239.148C396.969 238.651 397.468 238.133 397.945 237.595C398.354 237.134 398.664 236.684 398.875 236.243C399.086 235.795 399.192 235.313 399.192 234.795C399.192 234.22 399.061 233.724 398.799 233.309C398.54 232.89 398.168 232.554 397.725 232.34C397.271 232.11 396.756 231.995 396.181 231.995C395.58 231.995 395.056 232.117 394.609 232.36C394.167 232.597 393.806 232.961 393.573 233.405C393.33 233.858 393.209 234.399 393.209 235.025H389.268C389.268 233.74 389.559 232.625 390.141 231.679C390.722 230.733 391.537 230.001 392.585 229.483C393.634 228.965 394.842 228.706 396.21 228.706C397.616 228.706 398.84 228.956 399.882 229.454C400.93 229.947 401.745 230.631 402.327 231.506C402.909 232.382 403.199 233.385 403.199 234.517C403.199 235.258 403.052 235.99 402.758 236.713C402.471 237.435 401.956 238.237 401.215 239.119C400.473 239.995 399.428 241.046 398.079 242.274L395.213 245.083V245.217H403.458V248.611H389.46ZM423.013 247.859L419.95 228.463L427.716 227.236C429.142 227.011 430.366 227.034 431.386 227.307C432.406 227.579 433.216 228.053 433.814 228.729C434.412 229.398 434.787 230.219 434.941 231.191C435.061 231.949 435.014 232.639 434.802 233.261C434.594 233.87 434.241 234.418 433.773 234.86C433.286 235.315 432.717 235.672 432.095 235.912L432.125 236.101C432.863 236.015 433.61 236.117 434.298 236.398C435.019 236.688 435.652 237.16 436.135 237.768C436.648 238.392 436.98 239.181 437.13 240.135C437.293 241.164 437.182 242.123 436.798 243.012C436.42 243.893 435.772 244.646 434.855 245.27C433.937 245.894 432.752 246.32 431.3 246.55L423.013 247.859ZM426.585 243.858L429.928 243.33C431.07 243.15 431.869 242.8 432.325 242.282C432.779 241.757 432.948 241.129 432.833 240.396C432.748 239.859 432.544 239.406 432.22 239.037C431.883 238.659 431.446 238.385 430.959 238.246C430.449 238.087 429.865 238.06 429.209 238.163L425.771 238.706L426.585 243.858ZM425.332 235.931L428.373 235.451C428.934 235.362 429.418 235.186 429.823 234.921C430.233 234.649 430.535 234.31 430.73 233.904C430.931 233.497 430.991 233.038 430.91 232.527C430.799 231.826 430.461 231.3 429.894 230.95C429.334 230.598 428.599 230.494 427.69 230.638L424.574 231.13L425.332 235.931Z",
    fill: "#4C5256"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M225.807 313.944C230.743 315.331 234.154 317.737 235.945 321.096C237.623 324.239 237.652 327.722 237.369 330.14L206.751 321.546C209.324 317.002 214.939 310.894 225.807 313.944ZM253.283 334.608L244.243 332.07C244.787 328.628 244.992 323.075 242.231 317.842C239.501 312.673 234.619 309.068 227.72 307.132C215.892 303.812 208.41 308.587 204.215 313.178C202.222 315.357 200.804 317.687 199.838 319.606L190.47 316.977C189.806 316.79 189.111 316.736 188.426 316.818C187.741 316.9 187.078 317.116 186.477 317.453C185.875 317.791 185.346 318.244 184.919 318.787C184.493 319.329 184.177 319.951 183.991 320.615L173.197 359.07C172.821 360.412 172.993 361.849 173.675 363.064C174.358 364.279 175.495 365.173 176.837 365.55L239.649 383.18C240.314 383.367 241.008 383.42 241.694 383.338C242.379 383.256 243.041 383.04 243.643 382.702C244.245 382.364 244.774 381.911 245.201 381.368C245.627 380.826 245.943 380.205 246.129 379.54L256.923 341.087C257.3 339.745 257.127 338.309 256.445 337.094C255.762 335.879 254.625 334.985 253.283 334.608Z",
    fill: "#97CFF1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M241.692 262.564L232.099 299.188C232.099 299.188 235.788 302.374 237.334 306.241C238.88 310.108 238.38 313.274 237.481 312.298C236.932 311.701 236.104 311.091 234.936 310.304C233.356 309.24 232.623 308.002 231.459 308.063C229.447 308.173 227.295 309.052 228.911 313.222C230.477 317.269 236.042 318.445 234.631 319.487C231.045 322.137 228.506 318.496 228.506 318.496C228.506 318.496 227.452 320.127 226.024 320.098C224.596 320.071 224.047 317.558 224.047 317.558C224.047 317.558 222.978 318.965 221.352 318.736C219.728 318.507 219.375 316.202 219.375 316.202C219.375 316.202 216.821 318.482 215.16 315.719C213.499 312.956 210.226 305.988 220.234 297.075C220.234 297.075 229.608 250.418 233.857 247.927C238.104 245.435 241.692 262.564 241.692 262.564Z",
    fill: "#F1A993"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M220.74 292.6L232.665 297.369C232.792 297.42 232.929 297.443 233.066 297.438C233.203 297.432 233.337 297.398 233.46 297.337C233.582 297.276 233.691 297.19 233.778 297.084C233.865 296.978 233.929 296.855 233.965 296.723L234.299 295.508C234.362 295.279 234.339 295.035 234.235 294.822C234.13 294.608 233.952 294.441 233.732 294.35L221.852 289.462C221.725 289.41 221.589 289.385 221.452 289.389C221.315 289.393 221.181 289.426 221.057 289.486C220.934 289.546 220.825 289.631 220.737 289.736C220.649 289.841 220.584 289.963 220.546 290.095L220.164 291.43C220.098 291.662 220.12 291.91 220.227 292.126C220.333 292.342 220.516 292.511 220.74 292.6Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M220.21 290.937L234.258 295.997C234.565 296.108 234.904 296.092 235.2 295.953C235.495 295.814 235.724 295.563 235.835 295.256L242.817 259.762L260.06 239.234C260.289 238.595 258.248 231.389 257.608 231.16L253.019 214.353C252.38 214.124 226.553 252.344 226.553 252.344L219.469 289.361C219.414 289.513 219.389 289.675 219.397 289.836C219.404 289.998 219.444 290.156 219.513 290.303C219.581 290.449 219.678 290.581 219.798 290.689C219.918 290.798 220.058 290.882 220.21 290.937Z",
    fill: "#FB6A1F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M366.973 277.561C366.973 277.561 375.858 282.373 376.228 282.3C376.595 282.23 383.103 280.27 384.457 281.941C385.811 283.615 391.401 289.789 394.937 293.344C398.474 296.9 400.67 301.433 398.497 303.111C396.324 304.79 395.728 303.249 395.728 303.249C395.728 303.249 397.125 306.295 394.863 307.114C392.604 307.933 391.545 306.738 391.545 306.738C391.545 306.738 392.146 308.618 390.808 309.371C389.471 310.126 387.744 309.452 387.23 308.699C387.23 308.699 385.268 311.587 382.761 309.91C380.254 308.23 368.403 298.847 368.147 294.743L363.139 291.473L366.973 277.561Z",
    fill: "#F1A993"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M369.66 278.749L363.876 292.086C363.817 292.222 363.731 292.344 363.623 292.444C363.514 292.545 363.386 292.622 363.247 292.671C363.107 292.719 362.959 292.739 362.811 292.727C362.664 292.716 362.52 292.674 362.39 292.604L354.285 288.272C353.793 288.008 353.585 287.412 353.808 286.9L359.87 272.947C359.932 272.805 360.023 272.679 360.139 272.576C360.254 272.473 360.39 272.397 360.537 272.351C360.685 272.306 360.841 272.293 360.994 272.314C361.147 272.334 361.294 272.387 361.424 272.47L369.249 277.418C369.695 277.699 369.87 278.265 369.66 278.749Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M307.456 477.638L307.043 491.018L289.788 490.933L289.854 477.551L307.456 477.638Z",
    fill: "#FCD1BB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M289.788 490.932L306.663 491.014C306.921 491.017 307.162 491.043 307.412 491.103C309.822 491.681 323.536 495.14 335.616 501.819C338.618 503.48 337.388 508.071 333.957 508.053L293.034 507.85C292.597 507.848 292.164 507.76 291.761 507.59C291.358 507.421 290.992 507.174 290.684 506.863C290.376 506.553 290.133 506.184 289.967 505.78C289.802 505.375 289.718 504.941 289.72 504.504L289.788 490.932Z",
    fill: "#204D70"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M298.036 149.143C298.036 149.143 298.868 154.131 305.03 164.397C311.323 174.879 310.77 191.152 302.557 194.945C296.165 197.897 291.349 196.81 291.349 196.81L288.354 220.266L267.505 215.757L268.766 192.803L262.099 160.121L298.036 149.143Z",
    fill: "#F1A993"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M273.734 476.621L273.365 491.018L256.11 490.933L256.176 477.551L273.734 476.621Z",
    fill: "#FCD1BB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M256.11 490.932L272.985 491.014C273.243 491.017 273.484 491.043 273.734 491.103C276.144 491.681 289.858 495.14 301.938 501.819C304.94 503.48 303.71 508.071 300.279 508.053L259.356 507.85C258.919 507.848 258.486 507.76 258.083 507.59C257.68 507.421 257.314 507.174 257.006 506.863C256.698 506.553 256.455 506.184 256.289 505.78C256.124 505.375 256.04 504.941 256.042 504.504L256.11 490.932Z",
    fill: "#235386"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M308.621 315.189L310.759 477.656C310.77 478.521 310.439 479.355 309.837 479.976C309.236 480.597 308.413 480.955 307.548 480.972L289.313 481.325C288.47 481.341 287.654 481.032 287.034 480.462C286.413 479.891 286.037 479.103 285.983 478.262L282.225 420.198L276.286 479.03C276.206 479.828 275.835 480.568 275.246 481.111C274.656 481.653 273.887 481.961 273.086 481.975L257.139 482.259C256.281 482.274 255.452 481.952 254.829 481.362C254.206 480.772 253.84 479.961 253.809 479.104L247.854 315.189C247.845 314.308 308.621 315.189 308.621 315.189Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M307.456 477.64L289.186 477.877M273.543 478.157L255.869 478.432M291.67 473.621L287.301 367.762M297.47 317.272C297.47 317.272 297.714 338.672 290.772 341.757C283.831 344.842 292.576 325.693 289.617 317.142L297.47 317.272Z",
    stroke: "#F68D11"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M290.773 341.756L289.419 345.893L282.226 420.195M255.389 313.847L259.571 473.621",
    stroke: "#F68D11"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M248.719 227.065C249.69 217.973 253.083 207.643 264.449 205.78C272.527 204.457 284.211 204.775 292.037 207.08C299.48 209.269 305.939 213.929 310.303 220.344C317.443 230.843 328.357 246.912 328.408 246.955L367.924 274.371C368.295 274.656 368.558 275.059 368.67 275.513C368.783 275.967 368.738 276.446 368.543 276.871L362.039 291.043C361.913 291.322 361.726 291.569 361.492 291.767C361.258 291.965 360.983 292.108 360.687 292.186C360.391 292.264 360.081 292.275 359.78 292.218C359.48 292.161 359.195 292.038 358.948 291.857C350.116 285.387 314.82 263.166 314.775 263.11L308.335 256.973L309.682 317.473H246.709C246.709 317.473 246.56 247.295 248.719 227.065Z",
    fill: "#FB6A1F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M268.526 190.621L274.149 183.485C274.303 183.29 274.414 183.064 274.473 182.823C274.532 182.581 274.539 182.33 274.492 182.085C274.446 181.841 274.347 181.61 274.203 181.407C274.059 181.204 273.873 181.035 273.658 180.91C271.432 179.606 267.947 176.938 268.079 173.068C268.275 167.402 274.418 165.161 279.044 169.837C279.044 169.837 280.072 172.938 281.388 160.937C282.703 148.938 292.921 157.669 297.665 152.661C302.407 147.653 305.539 144.799 304.528 140.131C303.517 135.466 300.475 128.8 294.454 132.847C288.435 136.896 288 129.005 281.417 132.397C273.219 136.621 264.189 127.944 263.265 138.078C262.34 148.214 250.522 141.328 253.768 149.516C257.014 157.704 244.122 157.708 247.18 163.492C250.238 169.274 246.224 176.519 251.703 179.325C257.181 182.133 261.445 179.335 262.012 186.933C262.342 191.367 268.526 190.621 268.526 190.621Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M293.824 216.981C293.824 216.981 280.908 222.959 294.855 240.695C308.13 257.574 308.334 256.974 308.334 256.974M267.454 279.885C267.454 279.885 268.682 303.271 288.019 306.025M257.119 266.557C257.119 266.557 254.977 300.511 266.415 308.225",
    stroke: "#1A3B51"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M456.93 480.904L457.382 495.543L472.955 492.961L472.895 480.826L456.93 480.904Z",
    fill: "#F1A993"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M472.955 492.959C456.855 492.713 451.583 492.694 431.386 502.837C428.664 504.343 429.78 508.505 432.892 508.49L470.01 508.306C475.394 508.616 472.955 492.959 472.955 492.959Z",
    fill: "#204D70"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M529.374 480.827L529.75 495.516L545.374 496.707L545.3 481.671L529.374 480.827Z",
    fill: "#F1A993"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M536.493 492.897C534.457 492.907 527.988 493.332 524.639 496.659C520.312 500.955 520.889 508.392 522.647 508.398L550.181 508.489C551.512 508.594 551.072 502.075 547.993 497.93C545.222 494.195 542.915 492.868 536.493 492.897Z",
    fill: "#235386"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M565.569 329.554C560.705 330.778 557.303 333.039 555.46 336.279C553.737 339.308 553.615 342.715 553.828 345.088L584.008 337.501C581.61 332.986 576.283 326.861 565.569 329.554ZM538.139 349.031L547.051 346.79C546.612 343.408 546.558 337.973 549.399 332.926C552.208 327.942 557.082 324.548 563.881 322.839C575.54 319.907 582.731 324.779 586.714 329.381C588.604 331.568 589.928 333.885 590.822 335.786L600.056 333.464C601.379 333.132 602.779 333.339 603.949 334.04C605.119 334.74 605.963 335.876 606.296 337.199L615.825 375.103C615.99 375.758 616.025 376.439 615.926 377.107C615.828 377.775 615.599 378.417 615.252 378.997C614.905 379.576 614.448 380.082 613.906 380.485C613.363 380.887 612.747 381.179 612.092 381.343L550.177 396.91C548.854 397.242 547.454 397.035 546.283 396.335C545.113 395.635 544.268 394.499 543.935 393.176L534.406 355.271C534.074 353.949 534.28 352.548 534.98 351.378C535.68 350.208 536.817 349.364 538.139 349.031Z",
    fill: "#FEC474"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M531.819 299.223C533.478 310.524 540.659 362.058 539.86 402.399C539.858 402.521 539.862 402.641 539.877 402.762L549.258 483.16C549.304 483.558 549.266 483.961 549.145 484.343C549.025 484.725 548.825 485.077 548.559 485.376C548.292 485.675 547.966 485.915 547.601 486.079C547.235 486.243 546.839 486.328 546.439 486.328H528.152C526.832 486.328 525.686 485.418 525.389 484.132C522.218 470.474 505.295 397.387 504.032 387.693C502.635 376.991 501.24 362.568 501.24 362.568L489.631 409.929C489.617 409.993 489.602 410.057 489.592 410.123L476.695 485.009C476.58 485.676 476.23 486.28 475.709 486.712C475.188 487.144 474.53 487.375 473.853 487.365L454.673 487.062C454.287 487.056 453.907 486.97 453.555 486.812C453.203 486.654 452.887 486.425 452.627 486.141C452.366 485.856 452.166 485.522 452.039 485.157C451.912 484.793 451.861 484.407 451.888 484.022L457.963 398.968C457.969 398.895 457.977 398.823 457.987 398.749L473.404 295.824C473.509 295.121 473.874 294.482 474.428 294.035C474.981 293.589 475.682 293.366 476.392 293.412L529.196 296.819C529.843 296.857 530.457 297.117 530.934 297.555C531.412 297.993 531.724 298.582 531.819 299.223Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M501.267 362.568L494.045 305.16M496.597 358.026L481.024 409.091L470.463 480.824M528.359 321.789L533.524 402.032L544.12 480.824M486.181 309.368C486.181 309.368 488.944 328.787 496.598 328.517M514.034 305.159C514.034 305.159 516.951 317.732 525.971 328.516",
    stroke: "#FF6E53"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M549.604 280.153L561.157 315.273C561.157 315.273 556.116 317.975 554.501 321.714C552.885 325.455 553.289 328.564 554.193 327.634C554.748 327.066 555.574 326.491 556.737 325.754C558.312 324.753 559.063 323.562 560.198 323.655C562.162 323.814 564.244 324.732 562.554 328.769C560.912 332.685 555.438 333.686 556.789 334.742C560.227 337.431 562.808 333.94 562.808 333.94C562.808 333.94 563.795 335.562 565.194 335.572C566.591 335.582 567.193 333.139 567.193 333.139C567.193 333.139 568.204 334.544 569.799 334.365C571.394 334.183 571.801 331.938 571.801 331.938C571.801 331.938 574.238 334.237 575.938 331.579C577.637 328.921 581.023 322.192 571.473 313.206C571.473 313.206 563.551 267.316 559.463 264.763C555.376 262.213 549.604 280.153 549.604 280.153ZM399.194 300.426C399.194 300.426 399.137 298.905 395.837 295.378C392.536 291.85 388.993 286.862 386.36 287.238C386.36 287.238 384.808 294.039 382.338 294.629C379.868 295.22 379.942 291.379 379.626 288.342C379.309 285.307 383.159 281.421 385.786 280.953C388.714 280.433 391.881 283.575 395.744 283.951L408.233 279.878L411.862 294.698L404.553 296.988C404.553 296.988 402.436 298.399 399.194 300.426Z",
    fill: "#FCD1BB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M404.619 281.473L408.907 294.933C408.953 295.077 409.028 295.209 409.129 295.322C409.229 295.435 409.353 295.525 409.49 295.586C409.628 295.648 409.777 295.679 409.928 295.679C410.079 295.679 410.228 295.647 410.366 295.585L411.631 295.02C412.124 294.799 412.376 294.244 412.217 293.728L408.063 280.223C408.019 280.079 407.945 279.946 407.845 279.832C407.746 279.719 407.624 279.628 407.487 279.565C407.35 279.502 407.202 279.469 407.051 279.467C406.9 279.466 406.751 279.496 406.613 279.556L405.212 280.167C404.969 280.273 404.775 280.465 404.665 280.706C404.556 280.947 404.539 281.22 404.619 281.473Z",
    fill: "#FEECDB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M381.826 288.827L379.626 288.338C379.797 289.995 379.855 291.889 380.272 293.175C382.131 294.089 382.432 291.016 382.478 289.624C382.488 289.248 382.214 288.914 381.826 288.827Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M375.906 300.179C375.906 300.179 379.35 298.043 380.823 298.815C382.294 299.584 382.383 300.575 381.999 301.134C381.999 301.134 384.001 300.418 385.101 302.013C386.201 303.608 382.957 305.88 382.957 305.88C382.957 305.88 385.344 306.208 383.091 308.783C380.84 311.359 378.008 310.56 378.264 308.666C378.264 308.666 375.906 309.002 375.049 307.735C374.193 306.47 374.907 305.457 374.907 305.457C374.907 305.457 372.588 305.798 372.109 304.386C371.628 302.975 372.348 302.263 372.348 302.263C372.348 302.263 369.138 302.013 369.658 299.886C370.18 297.758 374.814 296.398 375.559 297.236C376.304 298.076 376.665 298.418 375.906 300.179Z",
    fill: "#FCD1BB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M372.926 300.1L372.439 299.334C372.393 299.263 372.363 299.184 372.35 299.1C372.337 299.017 372.341 298.932 372.362 298.851C372.384 298.769 372.422 298.693 372.474 298.627C372.526 298.561 372.592 298.506 372.666 298.467L373.749 297.863C374.28 297.568 374.969 297.735 375.289 298.24C375.611 298.744 375.439 299.392 374.911 299.689L373.793 300.312C373.648 300.393 373.479 300.416 373.318 300.376C373.157 300.337 373.017 300.238 372.926 300.1ZM378.526 301.618L378.04 300.853C377.994 300.782 377.964 300.703 377.95 300.62C377.937 300.536 377.941 300.451 377.962 300.37C377.984 300.288 378.022 300.212 378.074 300.146C378.126 300.08 378.192 300.025 378.266 299.986L379.35 299.38C379.607 299.238 379.909 299.198 380.194 299.268C380.479 299.338 380.728 299.512 380.891 299.757C381.211 300.263 381.042 300.911 380.512 301.206L379.393 301.831C379.248 301.911 379.079 301.933 378.918 301.893C378.757 301.854 378.618 301.756 378.526 301.618ZM381.861 304.164L381.374 303.398C381.329 303.327 381.298 303.248 381.285 303.165C381.272 303.082 381.276 302.997 381.298 302.915C381.319 302.834 381.357 302.758 381.409 302.692C381.461 302.626 381.527 302.572 381.601 302.532L382.685 301.927C382.942 301.784 383.243 301.744 383.529 301.814C383.814 301.884 384.063 302.059 384.224 302.305C384.3 302.423 384.351 302.556 384.373 302.694C384.395 302.833 384.388 302.975 384.353 303.111C384.317 303.247 384.254 303.374 384.167 303.484C384.08 303.594 383.971 303.685 383.847 303.751L382.728 304.377C382.583 304.457 382.413 304.48 382.253 304.441C382.092 304.401 381.952 304.302 381.861 304.164ZM382.2 308.154L381.688 307.549C381.67 307.528 381.656 307.504 381.648 307.478C381.64 307.451 381.637 307.424 381.64 307.396C381.643 307.369 381.652 307.342 381.666 307.319C381.68 307.295 381.699 307.274 381.721 307.258L382.571 306.623C382.7 306.529 382.86 306.486 383.018 306.504C383.177 306.522 383.323 306.599 383.428 306.72C383.478 306.778 383.516 306.845 383.539 306.918C383.562 306.991 383.569 307.068 383.56 307.144C383.552 307.219 383.528 307.293 383.489 307.359C383.451 307.425 383.399 307.482 383.337 307.527L382.46 308.183C382.421 308.212 382.373 308.225 382.324 308.22C382.276 308.214 382.232 308.191 382.2 308.154Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M558.993 313.673L572.729 310.366C573.349 310.215 573.701 309.559 573.485 308.958L573.01 307.656C572.92 307.411 572.744 307.206 572.515 307.081C572.286 306.956 572.019 306.919 571.764 306.977L557.994 310.149C557.847 310.183 557.709 310.247 557.589 310.338C557.469 310.429 557.369 310.545 557.297 310.677C557.224 310.809 557.181 310.955 557.168 311.105C557.156 311.255 557.176 311.406 557.226 311.548L557.734 312.988C557.822 313.238 557.999 313.446 558.232 313.572C558.464 313.699 558.735 313.735 558.993 313.673Z",
    fill: "#FEECDB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M531.123 299.42C526.697 301.24 499.067 311.577 473.67 297.378C473.516 297.294 473.386 297.171 473.293 297.022C473.2 296.873 473.147 296.703 473.139 296.527C472.933 291.394 472.081 249.773 471.651 239.129L453.15 265.641C453.097 265.707 413.015 295.568 413.015 295.568C412.883 295.666 412.73 295.732 412.568 295.759C412.407 295.786 412.241 295.774 412.084 295.725C411.928 295.675 411.785 295.589 411.669 295.473C411.552 295.358 411.465 295.216 411.414 295.06L405.964 278.478C405.899 278.28 405.895 278.067 405.953 277.867C406.011 277.667 406.128 277.489 406.288 277.356L438.454 250.953C438.535 250.887 462.997 207.022 469.429 204.339C477.879 200.815 486.833 196.149 495.367 197.158C513.363 199.284 496.677 190.77 536.414 201.64C552.132 205.94 570.819 287.211 573.796 306.756C573.833 307.006 573.777 307.262 573.638 307.473C573.498 307.684 573.286 307.837 573.041 307.901L557.569 312.063C557.312 312.133 557.038 312.101 556.804 311.974C556.57 311.847 556.395 311.634 556.314 311.38L533.676 240.506L531.759 298.5C531.753 298.698 531.69 298.891 531.577 299.054C531.464 299.217 531.306 299.344 531.123 299.42Z",
    fill: "#FF6E53"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M484.151 142.719C484.151 142.719 483.455 147.69 477.607 158.032C471.636 168.591 472.601 184.719 480.845 188.268C487.265 191.031 492.015 189.828 492.015 189.828L494.553 207.102L515.904 199.91L514.311 185.272L520.082 152.683L484.151 142.719Z",
    fill: "#FCD1BB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M478.818 132.443C478.724 130.821 480.325 129.583 481.854 130.134C485.021 131.277 491.23 132.493 502.58 131.533C524.259 129.701 534.448 148.873 533.631 162.366C532.931 173.934 520.229 179.86 516.089 184.526C515.196 185.53 513.603 185.475 512.709 184.47C510.594 182.097 507.65 178.558 507.612 177.215C507.553 175.118 513.677 175.093 514.302 168.839C514.93 162.587 506.61 161.375 503.964 166.082C501.319 170.787 503.256 154.124 498.832 152.298C494.761 150.616 479.621 146.365 478.818 132.443Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M515.859 198.411C515.859 198.411 517.51 211.955 503.843 213.175C490.179 214.394 493.823 199.55 493.823 199.55L515.859 198.411Z",
    fill: "#FCD1BB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M510.066 215.454L503.451 224.775C502.819 225.662 501.511 225.685 500.849 224.821L492.595 214.031C492.595 214.031 503.409 211.542 510.066 215.454Z",
    fill: "#FEECDB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M501.987 221.847L511.132 273.785C511.242 274.409 511.17 275.057 510.93 275.622L503.927 292.122C503.103 294.059 500.852 294.072 500.016 292.142L492.976 275.89C492.727 275.305 492.653 274.659 492.765 274.033L501.987 221.847Z",
    fill: "#FEECDB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M515.504 196.261C515.504 196.261 508.684 212.024 499.622 212.969L512.595 220.699C512.595 220.699 527.008 201.893 515.504 196.261Z",
    fill: "#DE614A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M493.096 196.93C493.096 196.93 494.051 210.487 501.674 213.477L491.137 220.699C491.137 220.699 481.868 199.66 493.096 196.93Z",
    fill: "#DE614A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M675.944 509.391H124",
    stroke: "#235388"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M695.955 324.396C686.368 329.389 679.013 337.97 673.724 347.416C668.435 356.862 665.026 367.247 661.682 377.539L658.7 430.634C669.862 411.575 678.819 389.179 681.236 367.219L673.826 366.549C678.81 365.787 682.987 362.171 685.646 357.875C688.304 353.58 689.675 348.634 691.009 343.762L681.931 345.101C689.09 340.255 694.111 332.842 695.955 324.396Z",
    fill: "#994200"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M695.955 324.396C686.368 329.389 679.013 337.97 673.724 347.416C668.435 356.862 665.026 367.247 661.682 377.539L658.7 430.634C669.862 411.575 678.819 389.179 681.236 367.219L673.826 366.549C678.81 365.787 682.987 362.171 685.646 357.875C688.304 353.58 689.675 348.634 691.009 343.762L681.931 345.101C689.09 340.255 694.111 332.842 695.955 324.396Z",
    fill: "#51B800"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M695.976 324.396C686.389 329.389 679.034 337.97 673.745 347.416C668.456 356.862 665.047 367.247 661.703 377.539L658.721 430.634C669.883 411.575 678.84 389.179 681.257 367.219L673.847 366.549C678.831 365.787 683.008 362.171 685.667 357.875C688.325 353.58 689.696 348.634 691.03 343.762L681.952 345.101C689.111 340.255 694.132 332.842 695.976 324.396Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M657.002 443.084C657.002 443.084 632.779 413.994 633.057 386.214H642.848C642.848 386.214 632.214 379.204 633.057 375.271C633.9 371.339 634.178 356.472 634.178 356.472L643.126 358.722C643.126 358.722 636.419 355.357 635.576 350.02C634.733 344.684 637.531 320 637.531 320C637.531 320 648.433 331.51 651.786 343.289C655.14 355.069 663.949 368.819 661.364 404.734C658.78 440.648 657.002 443.084 657.002 443.084ZM669.266 445.828C669.266 445.828 695.508 428.284 701.335 405.897L693.47 403.749C693.47 403.749 703.548 400.439 703.724 397.102C703.9 393.764 706.92 381.743 706.92 381.743L699.241 381.585C699.241 381.585 705.364 380.348 707.207 376.248C709.051 372.148 712.144 351.686 712.144 351.686C712.144 351.686 700.871 358.538 695.61 367.277C690.349 376.016 680.271 385.127 674.518 414.571C668.766 444.015 669.266 445.828 669.266 445.828Z",
    fill: "#51B800"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M644.206 345.373C644.25 345.467 644.281 345.567 644.298 345.671C644.354 345.903 644.428 346.2 644.511 346.6C644.697 347.418 644.956 348.581 645.289 350.049C645.623 351.518 646.021 353.387 646.447 355.525C646.873 357.664 647.374 360.1 647.874 362.796C648.911 368.188 650.013 374.64 651.134 381.818C652.255 388.995 653.32 396.907 654.293 405.237C655.266 413.567 655.979 421.525 656.544 428.768C657.109 436.01 657.47 442.546 657.692 448.031C657.822 450.774 657.887 453.256 657.952 455.469C658.017 457.682 658.063 459.532 658.072 461.047C658.081 462.563 658.072 463.744 658.072 464.58V465.51C658.081 465.615 658.081 465.721 658.072 465.826C658.056 465.721 658.056 465.615 658.072 465.51V464.58C658.072 463.734 657.998 462.553 657.942 461.038C657.887 459.523 657.831 457.626 657.739 455.46C657.646 453.294 657.553 450.811 657.396 448.022C657.137 442.537 656.701 436.01 656.145 428.777C655.59 421.544 654.802 413.595 653.848 405.265C652.945 397.447 651.908 389.646 650.736 381.864C649.789 375.504 648.739 369.159 647.587 362.833C647.163 360.401 646.712 357.975 646.234 355.553C645.808 353.415 645.475 351.565 645.169 350.059C644.863 348.553 644.65 347.418 644.483 346.591C644.419 346.219 644.363 345.922 644.326 345.661C644.277 345.569 644.236 345.473 644.206 345.373Z",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M653.668 460.899C653.668 460.899 631.502 435.667 624.629 420.411L629.816 418.189C626.055 418.812 622.192 417.185 619.275 414.721C616.357 412.257 614.208 409.012 612.105 405.814L618.95 404.652C612.656 402.842 607.302 398.676 604 393.021C612.077 394.36 619.386 398.814 625.407 404.373C630.186 408.989 634.527 414.037 638.375 419.453C640.309 422.06 641.992 424.843 643.404 427.765C647.128 435.491 653.677 451.63 653.668 460.899Z",
    fill: "#51B800"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M701.706 366.372C701.683 366.462 701.649 366.55 701.605 366.632L701.271 367.366C700.947 368.036 700.493 368.975 699.928 370.156C698.26 373.582 696.627 377.026 695.028 380.485C689.732 391.884 684.817 403.456 680.291 415.181C675.777 426.916 671.656 438.798 667.934 450.808C666.809 454.451 665.71 458.102 664.636 461.76C664.266 463.024 663.969 464.019 663.756 464.735L663.506 465.506C663.485 465.596 663.454 465.684 663.414 465.767C663.419 465.675 663.434 465.585 663.46 465.497C663.506 465.293 663.571 465.032 663.654 464.707C663.84 463.982 664.108 462.978 664.442 461.704C665.136 459.091 666.202 455.326 667.582 450.705C670.361 441.408 674.511 428.755 679.8 414.995C685.089 401.236 690.535 389.038 694.694 380.327C696.769 375.966 698.502 372.461 699.743 370.1C700.354 368.928 700.827 367.999 701.179 367.311L701.558 366.595C701.651 366.483 701.697 366.362 701.706 366.372ZM655.601 471.718C655.542 471.569 655.505 471.413 655.49 471.253C655.412 470.808 655.338 470.362 655.268 469.915C655.013 468.273 654.723 466.636 654.397 465.006C653.99 462.942 653.425 460.506 652.693 457.82C651.961 455.133 651.026 452.242 649.914 449.23C648.803 446.218 647.543 443.429 646.348 440.928C645.287 438.712 644.135 436.54 642.893 434.42C641.837 432.617 640.957 431.148 640.318 430.153L639.605 429C639.51 428.873 639.435 428.732 639.383 428.582C639.383 428.582 639.503 428.694 639.688 428.945L640.485 430.042C641.18 430.971 642.115 432.431 643.208 434.225C644.301 436.019 645.524 438.232 646.774 440.733C648.128 443.456 649.337 446.249 650.396 449.1C651.451 451.942 652.378 454.83 653.175 457.755C653.826 460.142 654.36 462.559 654.777 464.997C655.138 467.079 655.379 468.771 655.481 469.943C655.536 470.482 655.574 470.928 655.611 471.3C655.628 471.439 655.625 471.58 655.601 471.718Z",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M684.791 465.777H636.284V475.707H684.791V465.777ZM640.887 475.707L646.13 509.11H675.436L680.327 475.707H640.887Z",
    fill: "#994200"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M681.785 475.706C681.785 475.854 672.606 475.966 661.297 475.966C649.987 475.966 640.799 475.854 640.799 475.706C640.799 475.557 649.978 475.445 661.297 475.445C672.615 475.445 681.785 475.566 681.785 475.706Z",
    fill: "#263238"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M150.816 412.65C150.816 412.65 149.219 417.03 145.828 417.631C142.436 418.231 136.459 411.654 140.246 408.262C144.033 404.871 149.219 410.255 150.816 412.65Z",
    fill: "#51B800"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M145.367 418.014C143.15 418.014 140.427 415.701 139.302 413.388C138.278 411.286 138.537 409.294 139.984 408.011C140.459 407.566 141.028 407.232 141.649 407.035C142.27 406.838 142.928 406.782 143.573 406.872C146.589 407.254 149.714 410.42 151.079 412.46C151.109 412.505 151.128 412.556 151.135 412.609C151.142 412.662 151.137 412.716 151.12 412.767C151.051 412.951 149.414 417.346 145.872 417.967C145.706 418 145.536 418.015 145.367 418.014ZM142.993 407.513C142.053 407.515 141.148 407.873 140.462 408.516C138.783 410.017 139.397 412.023 139.916 413.088C141.123 415.565 143.962 417.612 145.756 417.298C148.561 416.8 150.096 413.463 150.417 412.692C149.127 410.823 146.214 407.916 143.518 407.547C143.344 407.526 143.168 407.515 142.993 407.513Z",
    fill: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M156.01 391.117C156.01 391.117 151.029 403.275 153.021 409.258C155.014 415.242 167.35 419.622 170.967 411.851C174.583 404.08 166.579 393.11 163.591 390.701C160.602 388.293 157.006 389.125 156.01 391.117Z",
    fill: "#51B800"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M164.054 416.367H163.419C158.697 416.108 153.867 412.956 152.693 409.388C150.68 403.357 155.484 391.513 155.688 391.008C155.969 390.502 156.361 390.065 156.833 389.729C157.306 389.394 157.847 389.169 158.418 389.07C159.361 388.89 160.333 388.925 161.261 389.17C162.189 389.416 163.05 389.866 163.781 390.489C166.845 392.945 174.923 404.087 171.252 412.035C169.97 414.825 167.424 416.367 164.054 416.367ZM156.316 391.26C156.139 391.697 151.437 403.438 153.334 409.149C154.433 412.437 159.073 415.426 163.46 415.664C165.412 415.774 168.919 415.405 170.645 411.707C174.159 404.1 166.333 393.355 163.365 390.987C162.715 390.43 161.949 390.025 161.123 389.8C160.296 389.576 159.43 389.539 158.588 389.691C158.119 389.77 157.674 389.952 157.284 390.223C156.893 390.494 156.568 390.848 156.33 391.26H156.316Z",
    fill: "#263238"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M185.089 396.301C185.089 396.301 176.519 404.072 175.536 411.85C174.554 419.627 180.312 422.411 186.303 421.401C192.294 420.392 195.269 405.259 193.475 398.28C191.68 391.3 185.089 396.301 185.089 396.301Z",
    fill: "#51B800"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M183.992 421.956C181.572 422.058 179.206 421.217 177.394 419.61C175.531 417.808 174.767 415.113 175.19 411.805C176.193 404 184.517 396.372 184.872 396.051C185.009 395.949 188.236 393.534 190.925 394.468C192.289 394.953 193.265 396.215 193.784 398.228C195.08 403.283 193.92 413.237 190.474 418.545C189.246 420.435 187.854 421.52 186.332 421.779C185.558 421.899 184.776 421.959 183.992 421.956ZM185.316 396.563C184.954 396.897 176.821 404.464 175.866 411.893C175.47 414.977 176.166 417.474 177.872 419.118C179.762 420.94 182.812 421.656 186.237 421.083C187.561 420.865 188.803 419.876 189.928 418.149C193.279 413.005 194.404 403.297 193.142 398.364C192.685 396.59 191.873 395.485 190.72 395.083C188.455 394.305 185.527 396.413 185.316 396.563Z",
    fill: "#263238"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M186.703 439.357C186.703 439.357 177.15 439.753 176.734 444.338C176.318 448.924 180.924 449.92 185.509 445.935C190.094 441.95 190.688 439.555 186.703 439.357Z",
    fill: "#51B800"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M180.041 448.775C179.41 448.783 178.786 448.643 178.219 448.366C176.854 447.683 176.22 446.237 176.383 444.312C176.806 439.482 186.277 439.031 186.68 439.018H186.714C188.345 439.099 189.32 439.557 189.6 440.382C190.037 441.645 188.768 443.548 185.725 446.203C183.814 447.874 181.767 448.775 180.041 448.775ZM186.693 439.7C186.27 439.7 177.427 440.218 177.066 444.374C176.922 446.005 177.441 447.206 178.526 447.786C180.198 448.632 182.845 447.82 185.274 445.739C188.911 442.573 189.143 441.201 188.959 440.662C188.734 439.939 187.601 439.768 186.693 439.7Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M177.044 445.748L176.758 445.127C177.072 444.984 184.379 441.654 187.784 441.033L187.9 441.716C184.584 442.309 177.119 445.714 177.044 445.748Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M188.833 469.357C188.833 469.357 181.798 462.854 178.27 465.802C174.743 468.749 177.26 472.707 183.319 473.151C189.379 473.594 191.501 472.325 188.833 469.357Z",
    fill: "#51B800"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M185.481 473.577C184.798 473.577 184.116 473.577 183.29 473.489C179.742 473.236 177.149 471.783 176.467 469.702C176.003 468.255 176.563 466.781 178.05 465.546C181.769 462.435 188.763 468.835 189.063 469.108C190.155 470.323 190.516 471.339 190.134 472.117C189.677 473.107 188.142 473.577 185.481 473.577ZM180.52 465.389C179.778 465.365 179.052 465.607 178.473 466.072C177.218 467.123 176.726 468.337 177.108 469.483C177.682 471.264 180.124 472.568 183.338 472.806C188.149 473.154 189.288 472.349 189.54 471.838C189.841 471.21 189.186 470.275 188.578 469.593C188.326 469.367 183.884 465.376 180.52 465.376V465.389Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M187.998 471.869C185.269 469.931 177.565 467.031 177.49 467.004L177.729 466.369C178.05 466.485 185.569 469.324 188.387 471.309L187.998 471.869Z",
    fill: "#263238"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M151.729 467.444C151.729 467.444 161.418 458.478 166.283 462.545C171.148 466.611 167.648 472.063 159.323 472.67C150.999 473.278 148.051 471.538 151.729 467.444Z",
    fill: "#51B800"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M156.315 473.132C152.719 473.132 150.652 472.498 150.024 471.222C149.526 470.198 150.024 468.854 151.484 467.217C151.887 466.841 161.453 458.087 166.496 462.304C168.502 463.975 169.225 465.961 168.638 467.892C167.731 470.71 164.169 472.668 159.338 473.03C158.331 473.092 157.323 473.126 156.315 473.132ZM151.983 467.674C151.116 468.636 150.181 469.98 150.618 470.908C150.979 471.645 152.583 472.805 159.29 472.314C163.766 471.986 167.185 470.157 167.99 467.646C168.522 465.995 167.833 464.276 166.059 462.788C161.569 459.035 152.358 467.346 151.983 467.687V467.674Z",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M152.847 470.799L152.451 470.239C156.333 467.51 166.684 463.607 167.121 463.416L167.36 464.051C167.251 464.119 156.654 468.117 152.847 470.799Z",
    fill: "#263238"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M162.995 448.926C162.995 448.926 161.999 453.702 158.41 455.511C154.821 457.319 148.441 453.511 151.832 447.732C155.223 441.953 161.201 446.538 162.995 448.926Z",
    fill: "#51B800"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M156.402 456.289C155.56 456.284 154.729 456.11 153.955 455.779C153.182 455.447 152.483 454.964 151.899 454.358C150.2 452.536 150.063 450.059 151.53 447.534C152.622 445.665 154.069 444.669 155.822 444.573C158.859 444.396 161.997 447.009 163.26 448.667C163.29 448.706 163.311 448.752 163.321 448.8C163.332 448.848 163.332 448.899 163.321 448.947C163.28 449.145 162.25 453.914 158.545 455.77C157.881 456.108 157.147 456.285 156.402 456.289ZM156.109 445.276H155.856C154.342 445.358 153.079 446.245 152.11 447.896C150.807 450.12 150.909 452.304 152.39 453.887C153.871 455.47 156.484 456.077 158.244 455.197C161.288 453.669 162.407 449.807 162.611 449.001C161.315 447.384 158.586 445.276 156.109 445.276Z",
    fill: "#263238"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M154.611 433.977C154.611 433.977 152.816 429.992 145.836 432.578C138.856 435.164 136.072 439.162 140.452 440.554C144.833 441.946 154.611 433.977 154.611 433.977Z",
    fill: "#51B800"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M141.59 441.058C141.167 441.064 140.746 441.004 140.341 440.881C138.437 440.274 138.014 439.271 138.001 438.534C137.953 436.487 140.976 434.017 145.711 432.263C152.903 429.588 154.895 433.791 154.909 433.832C154.941 433.901 154.949 433.979 154.931 434.054C154.914 434.128 154.872 434.194 154.813 434.242C154.479 434.542 146.407 441.058 141.59 441.058ZM150.098 432.038C148.676 432.079 147.272 432.37 145.95 432.898C140.907 434.774 138.649 437.121 138.683 438.52C138.683 439.448 139.706 439.96 140.546 440.226C144.36 441.44 152.684 435.054 154.158 433.887C153.797 433.348 152.691 432.038 150.098 432.038Z",
    fill: "#263238"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M142.082 438.249L141.646 437.73C145.672 434.319 152.911 433.486 153.245 433.459L153.314 434.141C153.218 434.141 145.951 434.994 142.082 438.249Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M174.527 386.139C174.527 386.139 175.721 388.929 178.116 388.329C180.511 387.728 181.105 384.139 184.891 385.136C188.678 386.132 191.872 390.519 191.872 388.547C191.872 386.575 187.095 381.369 181.705 381.369C176.315 381.369 174.725 383.546 174.527 386.139Z",
    fill: "#51B800"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M191.567 389.386C191.103 389.386 190.503 388.922 189.52 388.192C188.285 387.243 186.586 385.94 184.744 385.462C182.595 384.896 181.585 385.913 180.527 386.998C179.902 387.762 179.075 388.335 178.139 388.649C176.024 389.181 174.605 387.318 174.154 386.261C174.141 386.209 174.141 386.156 174.154 386.104C174.414 382.692 176.945 381 181.66 381C187.084 381 192.168 386.172 192.168 388.506C192.186 388.659 192.161 388.814 192.095 388.954C192.03 389.093 191.928 389.212 191.799 389.297C191.729 389.344 191.65 389.374 191.567 389.386ZM183.645 384.61C184.107 384.61 184.565 384.672 185.01 384.794C186.948 385.306 188.708 386.65 189.991 387.632C190.464 388.043 190.987 388.394 191.547 388.676C191.553 388.621 191.553 388.566 191.547 388.512C191.547 386.841 187.125 381.689 181.721 381.689C177.389 381.689 175.157 383.122 174.898 386.077C175.096 386.493 176.147 388.478 178.05 387.994C178.856 387.703 179.565 387.192 180.097 386.52C180.978 385.619 181.96 384.623 183.645 384.623V384.61ZM167.309 444.859C167.067 443.884 166.771 442.922 166.422 441.98C163.01 432.844 154.986 434.249 154.645 434.311L154.515 433.628C154.604 433.628 163.426 432.038 167.063 441.728C167.422 442.694 167.725 443.681 167.971 444.682L167.309 444.859Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M190.409 424.761C190.409 424.761 192.197 420.769 199.177 423.362C206.158 425.955 208.948 429.94 204.561 431.338C200.174 432.737 190.409 424.761 190.409 424.761Z",
    fill: "#51B800"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M203.417 431.824C198.6 431.824 190.555 425.314 190.187 425.001C190.128 424.954 190.086 424.889 190.069 424.816C190.051 424.743 190.059 424.666 190.091 424.598C190.091 424.557 192.097 420.347 199.289 423.022C204.024 424.782 207.054 427.245 206.999 429.299C206.999 430.029 206.563 431.039 204.659 431.64C204.257 431.765 203.838 431.827 203.417 431.824ZM190.842 424.659C192.315 425.819 200.647 432.206 204.454 430.998C205.293 430.732 206.296 430.22 206.317 429.286C206.351 427.921 204.093 425.54 199.057 423.67C193.387 421.562 191.34 423.888 190.842 424.659Z",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M202.335 429.019C199.087 425.007 192.1 425.341 192.032 425.348L191.991 424.666C192.291 424.666 199.401 424.304 202.868 428.589L202.335 429.019ZM184.623 425.864L184.35 425.237C186.28 424.396 188.406 424.108 190.491 424.404L190.361 425.087C188.413 424.816 186.429 425.085 184.623 425.864ZM158.947 417.828C154.853 413.673 150.814 412.99 150.759 412.984C150.704 412.977 144.741 411.428 142.503 413.468L142.046 412.97C144.55 410.67 150.643 412.247 150.916 412.288C151.059 412.288 155.201 412.97 159.438 417.323L158.947 417.828ZM159.959 393.771L159.293 393.92L159.666 395.585L160.332 395.435L159.959 393.771ZM170.082 483.646H169.4C169.4 483.299 170.287 449.213 169.4 438.925C168.513 428.636 164.391 416.492 164.351 416.37L160.093 397.362L160.775 397.219L165.026 416.185C165.06 416.274 169.209 428.52 170.096 438.87C170.983 449.22 170.096 483.305 170.082 483.646ZM187.932 401.067L187.163 402.711L187.781 403L188.55 401.356L187.932 401.067ZM172.163 483.605H171.48C171.48 483.292 171.794 452.167 172.975 443.312C174.155 434.456 178.897 420.456 178.945 420.313L186.273 404.621L186.894 404.914L179.58 420.606C179.545 420.715 174.803 434.647 173.65 443.448C172.497 452.249 172.163 483.292 172.163 483.605Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M173.927 483.656L173.245 483.622C174.425 463.584 176.506 445.573 176.527 445.416L177.209 445.491C177.182 445.648 175.101 463.646 173.927 483.656ZM167.092 483.605H166.409C166.409 483.318 166.989 454.95 165.829 451.211C165.427 449.915 164.895 449.131 164.281 448.953C164.091 448.909 163.893 448.909 163.702 448.953C163.512 448.997 163.334 449.083 163.182 449.206L163.107 449.267H163.005C162.95 449.267 157.628 449.949 155.738 452.951L155.165 452.59C157.102 449.492 162.063 448.708 162.827 448.598C163.06 448.429 163.328 448.312 163.611 448.257C163.894 448.202 164.185 448.209 164.465 448.278C165.324 448.53 166 449.444 166.512 451.007C167.672 454.875 167.112 482.438 167.092 483.605ZM168.583 483.646L167.9 483.612C167.9 483.332 169.32 455.639 167.784 447.07L168.467 446.947C170.002 455.619 168.596 483.366 168.583 483.646Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M174.738 483.646C174.738 481.947 174.369 441.988 177.931 432.511C178.784 429.975 180.412 427.77 182.584 426.207L182.967 426.773C180.915 428.26 179.377 430.349 178.566 432.75C175.058 442.11 175.42 483.236 175.42 483.639L174.738 483.646ZM171.276 483.643L170.594 483.555C171.426 477.414 169.734 441.726 164.944 427.972C163.853 424.678 162.157 421.617 159.943 418.945L160.468 418.502C162.73 421.241 164.465 424.375 165.586 427.746C170.41 441.583 172.115 477.462 171.276 483.643Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M172.163 483.604H171.48C171.48 483.256 171.692 448.645 171.978 431.555H172.661C172.374 448.638 172.163 483.256 172.163 483.604ZM172.695 429.405H172.013C172.252 415.61 172.47 405.97 172.695 400.75C173.207 387.324 173.951 386.068 174.299 385.857C174.633 385.106 176.23 382.357 181.873 382.725L181.832 383.407C176.018 383.032 174.926 386.136 174.879 386.252L174.715 386.757L174.592 386.648C174.34 387.385 173.78 390.175 173.378 400.778C173.152 405.983 172.934 415.617 172.695 429.405Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M164.736 442.458C164.736 442.458 159.748 438.016 161.748 435.826C163.747 433.635 176.077 432.039 179.686 434.877C183.296 437.716 175.306 441.7 172.31 442.601C169.315 443.502 165.746 443.181 164.736 442.458Z",
    fill: "#51B800"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M168.308 443.487C166.609 443.487 165.149 443.201 164.507 442.73C164.364 442.607 161.055 439.632 160.932 437.237C160.908 436.943 160.946 436.648 161.042 436.37C161.138 436.092 161.291 435.836 161.491 435.62C163.654 433.246 176.148 431.663 179.914 434.631C180.287 434.872 180.58 435.217 180.759 435.623C180.937 436.03 180.992 436.48 180.917 436.917C180.392 439.598 174.708 442.287 172.422 442.948C171.083 443.32 169.698 443.502 168.308 443.487ZM164.896 442.191C165.797 442.826 169.215 443.139 172.163 442.273C174.66 441.543 179.751 438.936 180.181 436.76C180.228 436.447 180.181 436.126 180.046 435.84C179.911 435.553 179.694 435.313 179.423 435.149C176.012 432.461 163.846 433.976 161.949 436.057C161.811 436.208 161.706 436.386 161.64 436.58C161.574 436.774 161.55 436.979 161.567 437.183C161.703 439.223 164.698 441.993 164.924 442.191H164.896Z",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M169.549 440.144H168.866C168.871 439.687 168.91 439.231 168.982 438.779L169.665 438.882C169.596 439.299 169.557 439.721 169.549 440.144ZM170.082 437.04L169.399 436.849C169.741 435.696 170.177 434.573 170.703 433.492L171.31 433.799C170.819 434.847 170.408 435.93 170.082 437.04Z",
    fill: "#263238"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M164.736 471.516C164.736 471.516 159.748 467.074 161.748 464.884C163.747 462.694 176.077 461.097 179.686 463.936C183.296 466.774 175.306 470.759 172.31 471.66C169.315 472.56 165.746 472.246 164.736 471.516Z",
    fill: "#51B800"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M168.308 472.516C166.609 472.516 165.149 472.229 164.507 471.758C164.364 471.636 161.055 468.661 160.932 466.3C160.908 466.006 160.945 465.711 161.042 465.433C161.138 465.154 161.291 464.899 161.491 464.683C163.654 462.308 176.148 460.725 179.914 463.693C180.286 463.934 180.58 464.28 180.758 464.686C180.936 465.092 180.992 465.542 180.917 465.979C180.392 468.661 174.708 471.349 172.422 472.011C171.081 472.371 169.696 472.541 168.308 472.516ZM164.896 471.219C165.797 471.854 169.215 472.168 172.163 471.301C174.66 470.571 179.751 467.965 180.181 465.795C180.229 465.481 180.182 465.159 180.048 464.871C179.913 464.584 179.695 464.342 179.423 464.178C176.012 461.489 163.846 463.004 161.949 465.085C161.81 465.236 161.705 465.414 161.639 465.608C161.573 465.802 161.549 466.007 161.567 466.211C161.703 468.279 164.698 471.049 164.924 471.247L164.896 471.219Z",
    fill: "#263238"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M169.549 469.202H168.866C168.866 466.288 170.654 462.685 170.729 462.535L171.336 462.842C171.323 462.876 169.549 466.452 169.549 469.202Z",
    fill: "#263238"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M168.422 459.228C168.422 459.228 165.01 456.212 166.375 454.725C167.74 453.237 176.125 452.152 178.561 454.083C180.997 456.014 175.58 458.73 173.553 459.324C171.527 459.917 169.097 459.719 168.422 459.228Z",
    fill: "#51B800"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M170.869 460.032C169.953 460.093 169.037 459.909 168.215 459.5C168.119 459.411 165.84 457.364 165.758 455.692C165.74 455.478 165.767 455.263 165.836 455.06C165.906 454.857 166.016 454.67 166.161 454.512C167.648 452.888 176.232 451.783 178.811 453.83C179.071 454.007 179.274 454.254 179.396 454.543C179.519 454.832 179.555 455.151 179.501 455.46C179.112 457.439 175.024 459.247 173.66 459.643C172.752 459.902 171.813 460.033 170.869 460.032ZM168.631 458.961C169.218 459.363 171.531 459.561 173.469 458.995C175.14 458.51 178.552 456.771 178.832 455.338C178.857 455.145 178.826 454.949 178.743 454.773C178.659 454.598 178.527 454.45 178.361 454.348C176.082 452.547 167.908 453.557 166.639 454.955C166.554 455.046 166.49 455.154 166.451 455.272C166.412 455.39 166.399 455.515 166.413 455.638C166.468 456.784 168.024 458.408 168.631 458.961Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M171.813 457.657H171.131C171.256 456.063 171.69 454.507 172.407 453.078L173.014 453.385C172.35 454.721 171.943 456.17 171.813 457.657Z",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M177.228 478.658H163.739V508.575H177.228V478.658Z",
    fill: "#994200"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M177.27 508.907H163.78C163.735 508.907 163.691 508.898 163.649 508.881C163.608 508.864 163.57 508.839 163.539 508.807C163.507 508.776 163.482 508.738 163.465 508.697C163.448 508.655 163.439 508.611 163.439 508.566V478.656C163.439 478.565 163.475 478.479 163.539 478.414C163.603 478.35 163.689 478.314 163.78 478.314H177.27C177.315 478.314 177.359 478.323 177.401 478.34C177.442 478.357 177.48 478.382 177.511 478.414C177.543 478.446 177.568 478.484 177.585 478.525C177.602 478.567 177.611 478.611 177.611 478.656V508.566C177.611 508.656 177.575 508.743 177.511 508.807C177.447 508.871 177.36 508.907 177.27 508.907ZM164.121 508.224H176.928V478.997H164.121V508.224Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_55_882)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55_882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 413,
    y: 174,
    width: 4,
    height: 4
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M413.301 174.478H416.666V177.848H413.301V174.478Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55_882)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_55_882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 413,
    y: 174,
    width: 4,
    height: 4
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M415.384 174.645C415.212 174.604 415.037 174.591 414.859 174.603C414.682 174.616 414.511 174.655 414.346 174.719C414.183 174.784 414.033 174.871 413.898 174.98C413.763 175.09 413.65 175.217 413.558 175.361C413.533 175.416 413.501 175.464 413.474 175.513C413.429 175.598 413.398 175.686 413.378 175.78C413.352 175.879 413.336 175.98 413.33 176.082C413.325 176.185 413.33 176.287 413.346 176.389C413.362 176.491 413.387 176.59 413.424 176.686C413.461 176.783 413.507 176.876 413.563 176.963C413.618 177.052 413.683 177.133 413.756 177.21C413.829 177.286 413.909 177.355 413.996 177.417C414.084 177.478 414.176 177.531 414.275 177.575C414.373 177.618 414.475 177.653 414.581 177.678C414.751 177.717 414.922 177.73 415.097 177.718C415.27 177.706 415.439 177.669 415.601 177.608C415.762 177.546 415.91 177.463 416.045 177.358C416.179 177.253 416.294 177.131 416.387 176.993L416.51 176.762H416.516C416.548 176.689 416.575 176.615 416.593 176.537C416.618 176.438 416.634 176.337 416.639 176.234C416.644 176.133 416.637 176.031 416.621 175.929C416.604 175.828 416.577 175.729 416.54 175.632C416.503 175.537 416.457 175.445 416.401 175.357C416.345 175.269 416.28 175.187 416.207 175.112C416.134 175.035 416.054 174.967 415.967 174.906C415.88 174.845 415.787 174.792 415.689 174.748C415.592 174.705 415.49 174.67 415.384 174.645Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_55_882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.461 173.968L412.663 177.6L416.507 178.351L417.304 174.72L413.461 173.968Z",
    fill: "url(#paint0_linear_55_882)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_55_882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 412,
    y: 190,
    width: 5,
    height: 4
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M412.975 190.409H416.57V193.779H412.975V190.409Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_55_882)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_55_882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 413,
    y: 190,
    width: 4,
    height: 4
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M415.268 190.594C415.094 190.553 414.92 190.54 414.742 190.553C414.565 190.565 414.394 190.603 414.23 190.668C414.066 190.732 413.916 190.82 413.781 190.929C413.647 191.039 413.533 191.166 413.441 191.309L413.352 191.461C413.312 191.547 413.28 191.637 413.255 191.728C413.206 191.909 413.192 192.092 413.213 192.277C413.235 192.464 413.288 192.64 413.376 192.808C413.464 192.975 413.579 193.122 413.723 193.25C413.868 193.38 414.03 193.48 414.212 193.553C414.395 193.626 414.584 193.668 414.782 193.676C414.98 193.686 415.172 193.662 415.361 193.606C415.55 193.55 415.723 193.465 415.88 193.351C416.035 193.236 416.167 193.1 416.271 192.942C416.316 192.869 416.354 192.79 416.393 192.717H416.399C416.431 192.644 416.451 192.572 416.477 192.493C416.502 192.392 416.518 192.292 416.523 192.189C416.528 192.086 416.523 191.984 416.506 191.882C416.49 191.781 416.463 191.681 416.427 191.585C416.39 191.489 416.343 191.395 416.287 191.308C416.231 191.22 416.167 191.138 416.093 191.062C416.02 190.985 415.94 190.917 415.853 190.856C415.765 190.795 415.673 190.742 415.573 190.698C415.475 190.653 415.373 190.619 415.268 190.594Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_55_882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.329 189.915L412.53 193.557L416.391 194.311L417.191 190.669L413.329 189.915Z",
    fill: "#2771E0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_55_882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 167,
    width: 29,
    height: 34
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M383.333 167.333H411.994V200.421H383.333V167.333Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_55_882)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_55_882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 167,
    width: 29,
    height: 34
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M410.433 194.513C410.202 194.467 409.971 194.469 409.74 194.517C409.509 194.564 409.298 194.654 409.108 194.786C408.464 195.219 407.784 195.598 407.072 195.924C406.36 196.249 405.623 196.516 404.862 196.725C404.103 196.934 403.329 197.081 402.543 197.166C401.757 197.252 400.968 197.276 400.176 197.237L399.952 197.225C399.303 197.183 398.66 197.1 398.023 196.976C390.352 195.478 385.426 188.397 387.014 181.165C388.602 173.935 396.107 169.28 403.771 170.78C405.649 171.144 407.376 171.839 408.954 172.866H408.96C409.055 172.948 409.157 173.02 409.269 173.079C409.42 173.154 409.578 173.209 409.745 173.243C409.93 173.278 410.117 173.282 410.304 173.258C410.492 173.233 410.671 173.181 410.839 173.099C411.008 173.019 411.158 172.914 411.289 172.785C411.42 172.655 411.526 172.51 411.605 172.348C411.683 172.186 411.733 172.016 411.751 171.838C411.769 171.66 411.756 171.485 411.711 171.31C411.668 171.137 411.594 170.975 411.492 170.824C411.389 170.675 411.263 170.544 411.115 170.434H411.109L410.999 170.361L410.973 170.343C408.995 169.029 406.822 168.142 404.453 167.679C394.974 165.829 385.696 171.575 383.728 180.523C381.761 189.471 387.856 198.219 397.341 200.076C398.517 200.307 399.705 200.421 400.906 200.421C402.109 200.421 403.297 200.305 404.473 200.074C405.649 199.843 406.787 199.501 407.889 199.049C408.991 198.596 410.031 198.043 411.012 197.389L411.043 197.37L411.115 197.316L411.147 197.298C411.456 197.058 411.654 196.756 411.738 196.387C411.761 196.285 411.772 196.182 411.772 196.078C411.774 195.974 411.763 195.871 411.743 195.768C411.721 195.667 411.691 195.567 411.649 195.47C411.608 195.375 411.557 195.282 411.495 195.195C411.435 195.109 411.366 195.028 411.289 194.953C411.212 194.879 411.128 194.813 411.036 194.755C410.945 194.696 410.848 194.647 410.747 194.606C410.645 194.564 410.54 194.534 410.433 194.513Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_55_882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.503 162.005L376.37 199.061L410.604 205.749L418.737 168.694L384.503 162.005Z",
    fill: "url(#paint1_linear_55_882)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_55_882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 389,
    y: 173,
    width: 21,
    height: 21
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M409.216 173.559H389.935V193.779H409.216V173.559Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_55_882)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_55_882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 390,
    y: 173,
    width: 20,
    height: 21
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M403.631 193.317C402.754 193.548 401.86 193.67 400.949 193.683C400.038 193.695 399.14 193.597 398.256 193.39L397.883 193.293H397.877C397.681 193.241 397.487 193.182 397.296 193.119C397.104 193.055 396.915 192.987 396.728 192.913C396.54 192.84 396.355 192.761 396.172 192.677C395.989 192.593 395.809 192.505 395.631 192.411C395.454 192.318 395.28 192.219 395.109 192.116C394.937 192.013 394.77 191.906 394.604 191.794C394.439 191.681 394.278 191.565 394.12 191.444C393.963 191.323 393.808 191.199 393.659 191.07C393.508 190.94 393.363 190.808 393.22 190.67C393.078 190.534 392.94 190.392 392.808 190.248C392.673 190.103 392.545 189.956 392.421 189.804C392.296 189.653 392.176 189.497 392.061 189.339C391.946 189.181 391.836 189.021 391.73 188.857C391.625 188.693 391.525 188.525 391.43 188.357C391.336 188.187 391.245 188.016 391.161 187.841C391.077 187.666 390.997 187.49 390.923 187.312C390.849 187.134 390.78 186.953 390.718 186.771C390.655 186.588 390.598 186.405 390.545 186.219C390.494 186.034 390.448 185.847 390.408 185.659C390.368 185.471 390.334 185.282 390.304 185.093C390.275 184.903 390.252 184.713 390.235 184.521C390.217 184.331 390.206 184.139 390.201 183.948C390.196 183.756 390.196 183.565 390.202 183.373C390.207 183.182 390.22 182.99 390.238 182.799C390.254 182.609 390.279 182.418 390.308 182.228C390.337 182.039 390.372 181.85 390.413 181.662C390.454 181.474 390.501 181.287 390.552 181.102C390.604 180.918 390.662 180.733 390.725 180.551C390.789 180.369 390.858 180.189 390.932 180.01C391.006 179.832 391.085 179.656 391.171 179.482C391.257 179.308 391.346 179.136 391.442 178.967C391.537 178.798 391.638 178.632 391.744 178.468C391.849 178.304 391.96 178.143 392.075 177.986C392.191 177.828 392.311 177.673 392.436 177.522C392.56 177.37 392.69 177.223 392.824 177.078C392.957 176.935 393.096 176.794 393.238 176.657C393.381 176.521 393.526 176.388 393.677 176.259C393.827 176.131 393.982 176.005 394.14 175.885C394.299 175.764 394.459 175.648 394.624 175.537C394.79 175.426 394.958 175.318 395.13 175.215C395.302 175.113 395.476 175.015 395.654 174.922C395.832 174.828 396.012 174.741 396.194 174.657C396.378 174.574 396.563 174.496 396.751 174.423C396.938 174.349 397.129 174.282 397.32 174.218C397.512 174.155 397.706 174.097 397.901 174.045C398.096 173.992 398.293 173.945 398.492 173.903C398.69 173.862 398.889 173.826 399.089 173.794C399.29 173.763 399.492 173.737 399.693 173.718C399.895 173.698 400.098 173.682 400.301 173.674C400.504 173.664 400.707 173.66 400.91 173.663C401.113 173.664 401.316 173.671 401.519 173.684C401.722 173.698 401.923 173.715 402.125 173.739C402.327 173.763 402.527 173.793 402.728 173.828C402.927 173.863 403.126 173.902 403.322 173.948C403.52 173.993 403.717 174.043 403.911 174.1C404.105 174.156 404.298 174.217 404.488 174.284C404.678 174.35 404.867 174.422 405.053 174.498C405.239 174.576 405.422 174.657 405.604 174.743C405.785 174.831 405.964 174.922 406.14 175.019C406.315 175.115 406.487 175.216 406.657 175.322C406.827 175.427 406.992 175.537 407.156 175.652C407.318 175.767 407.478 175.885 407.633 176.008C407.788 176.132 407.94 176.26 408.088 176.391C408.236 176.523 408.379 176.658 408.519 176.797L408.795 177.089C408.832 177.132 408.864 177.179 408.892 177.228C408.999 177.405 409.071 177.594 409.106 177.795C409.141 177.996 409.138 178.196 409.098 178.396C409.057 178.596 408.98 178.784 408.868 178.957C408.755 179.131 408.614 179.282 408.445 179.407C408.275 179.533 408.088 179.627 407.882 179.69C407.677 179.753 407.466 179.779 407.25 179.77C407.035 179.762 406.828 179.717 406.629 179.638C406.43 179.558 406.252 179.449 406.095 179.309L405.928 179.133C405.639 178.844 405.325 178.58 404.987 178.343C404.649 178.106 404.29 177.901 403.912 177.725C403.534 177.549 403.144 177.405 402.738 177.296C402.333 177.186 401.921 177.112 401.502 177.072C401.082 177.033 400.662 177.029 400.242 177.06C399.822 177.093 399.409 177.159 399.001 177.262C398.594 177.363 398.2 177.498 397.818 177.667C397.436 177.836 397.074 178.036 396.73 178.266C396.387 178.495 396.068 178.754 395.774 179.037C395.479 179.322 395.214 179.629 394.979 179.959C394.743 180.288 394.54 180.634 394.37 180.998C394.2 181.362 394.066 181.737 393.968 182.124C393.87 182.511 393.808 182.902 393.785 183.299C393.761 183.697 393.775 184.091 393.827 184.486C393.879 184.881 393.968 185.268 394.093 185.647C394.219 186.027 394.38 186.393 394.576 186.745C394.771 187.098 394.998 187.43 395.256 187.744C395.515 188.057 395.801 188.347 396.115 188.613C396.429 188.877 396.766 189.114 397.125 189.321C397.485 189.53 397.86 189.705 398.253 189.85C398.645 189.994 399.049 190.104 399.462 190.181C399.876 190.256 400.293 190.297 400.714 190.301C401.136 190.306 401.554 190.275 401.971 190.209C402.385 190.143 402.791 190.043 403.188 189.908C404.065 189.612 404.848 189.167 405.535 188.573C405.541 188.573 405.541 188.573 405.541 188.567L405.689 188.439C405.77 188.375 405.855 188.316 405.947 188.263C406.132 188.162 406.33 188.092 406.541 188.056C406.751 188.022 406.963 188.022 407.174 188.057C407.386 188.093 407.584 188.163 407.767 188.266C407.952 188.369 408.112 188.498 408.247 188.655C408.383 188.813 408.485 188.986 408.554 189.178C408.623 189.369 408.655 189.567 408.649 189.769C408.643 189.971 408.601 190.166 408.521 190.354C408.44 190.542 408.329 190.711 408.185 190.86C408.124 190.931 408.055 190.993 407.978 191.048H407.972C406.719 192.135 405.273 192.891 403.631 193.317Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_55_882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.435 178.019L405.02 166.286L417.902 189.338L394.316 201.069L381.435 178.019Z",
    fill: "url(#paint2_linear_55_882)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_55_882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 396,
    y: 180,
    width: 15,
    height: 7
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M410.524 180.605H396.472V186.732H410.524V180.605Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_55_882)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_55_882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 396,
    y: 180,
    width: 15,
    height: 7
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M396.654 183.264C396.677 183.1 396.715 182.937 396.767 182.779C396.82 182.62 396.886 182.467 396.965 182.319C397.046 182.17 397.138 182.03 397.244 181.896C397.348 181.762 397.464 181.639 397.592 181.524C397.72 181.409 397.856 181.305 398.002 181.212C398.147 181.118 398.301 181.037 398.461 180.969C398.622 180.899 398.787 180.844 398.958 180.801C399.128 180.759 399.301 180.73 399.476 180.716C399.652 180.701 399.827 180.699 400.003 180.713C400.18 180.726 400.352 180.753 400.523 180.794C400.694 180.835 400.86 180.888 401.021 180.955C401.183 181.022 401.336 181.102 401.484 181.194C401.631 181.286 401.769 181.387 401.898 181.501C402.026 181.615 402.143 181.738 402.25 181.871C402.357 182.003 402.451 182.143 402.532 182.29C402.614 182.437 402.682 182.59 402.737 182.748C403.353 183.076 404.202 183.276 405.148 183.276C405.957 183.276 406.704 183.125 407.289 182.876C407.438 182.635 407.641 182.447 407.9 182.311C408.027 182.242 408.162 182.189 408.305 182.155C408.389 182.135 408.476 182.124 408.563 182.118C408.801 182.096 409.034 182.122 409.261 182.197C409.488 182.271 409.687 182.386 409.861 182.542H409.867L409.99 182.669C410.055 182.739 410.111 182.813 410.157 182.894C410.211 182.984 410.255 183.077 410.289 183.174C410.323 183.272 410.347 183.372 410.361 183.475C410.374 183.576 410.378 183.679 410.369 183.781C410.361 183.884 410.343 183.984 410.314 184.084C410.285 184.183 410.246 184.279 410.197 184.371C410.148 184.462 410.091 184.549 410.023 184.631C409.957 184.711 409.881 184.785 409.8 184.853C409.717 184.92 409.627 184.979 409.533 185.029C409.232 185.191 408.907 185.257 408.563 185.224C408.475 185.216 408.389 185.202 408.305 185.181C408.037 185.118 407.802 184.998 407.598 184.823L407.411 184.636C407.411 184.632 407.409 184.63 407.405 184.63L407.289 184.466C406.704 184.211 405.957 184.059 405.148 184.059C404.202 184.059 403.353 184.26 402.737 184.592C402.674 184.765 402.596 184.931 402.502 185.09C402.407 185.248 402.299 185.398 402.175 185.538C402.051 185.678 401.914 185.806 401.766 185.922C401.617 186.038 401.459 186.14 401.29 186.228C401.122 186.317 400.946 186.39 400.763 186.449C400.579 186.506 400.393 186.548 400.201 186.573C400.01 186.598 399.818 186.607 399.626 186.599C399.433 186.591 399.243 186.566 399.054 186.525C398.866 186.483 398.684 186.427 398.507 186.354C398.33 186.281 398.161 186.192 398.002 186.091C397.842 185.988 397.694 185.873 397.556 185.745C397.42 185.617 397.296 185.478 397.186 185.328C397.076 185.179 396.982 185.021 396.903 184.855C396.824 184.688 396.761 184.517 396.715 184.34C396.67 184.163 396.642 183.983 396.632 183.801C396.621 183.619 396.628 183.439 396.654 183.258V183.264Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_55_882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.811 178.123L411.62 186.364L397.187 189.185L395.377 180.943L409.811 178.123Z",
    fill: "url(#paint3_linear_55_882)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_882",
    x1: 413.063,
    y1: 175.782,
    x2: 416.886,
    y2: 176.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#2B6ADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#2E66D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#3160D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#3260D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#335ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#355BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#355ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#3855CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3953CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3B4FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3C4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#3D4CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#453EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#463DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#473CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#4E2FB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#4F2EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#4F2DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#502DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#502CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#512BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#512AAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#5229AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#5228AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#5328AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#5327AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5327AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55_882",
    x1: 390.917,
    y1: 160.004,
    x2: 405.671,
    y2: 207.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#0093D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#0095D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#0097D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334773,
    stopColor: "#0098D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#0098D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#009AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#009DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00A0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#00A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00A1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#00A3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00A5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#00A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00A6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#00A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00ADCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665227,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#00B2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#00B5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#00B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#00B9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00BBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_55_882",
    x1: 387.931,
    y1: 190.693,
    x2: 411.22,
    y2: 176.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405615,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#00B6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#00B6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#00B5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#00B5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#00B5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#00B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#00B5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#00B5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00B4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00B4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00B4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00B3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00B3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00B3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00B1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959438,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_55_882",
    x1: 412.212,
    y1: 189.057,
    x2: 397.851,
    y2: 192.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2770DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2B6BDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#2D67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#2E65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3260D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#345BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523437,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3559CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#3856CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3954CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#3D4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#3D4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4048C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#4145C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#453EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#463CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#473BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#4938B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#4A35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2FB2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 530,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_55_882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3333,
    height: 33.3333,
    fill: "white",
    transform: "translate(383.333 167.333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroB2B);
export default __webpack_public_path__ + "static/media/hero-b2b.b8692e38a4e61189a96e8cc30759fe2a.svg";
export { ForwardRef as ReactComponent };